/**
 * 判断题类型定义
 */

import { QuestionType } from '../../types';
import type { QuestionTypeMetadata } from '../types';

export const trueFalseTypeMetadata: QuestionTypeMetadata = {
  type: QuestionType.TRUE_FALSE,
  name: '判断题',
  description: '判断题目陈述是否正确',

  requiredFields: ['content', 'correctAnswer'],
  optionalFields: ['explanation', 'difficulty', 'tags', 'imageUrl', 'section', 'level'],

  fields: {
    content: {
      name: 'content',
      type: 'text',
      required: true,
      description: '题目内容',
    },
    correctAnswer: {
      name: 'correctAnswer',
      type: 'boolean',
      required: true,
      description: '正确答案（true/false）',
    },
    explanation: {
      name: 'explanation',
      type: 'text',
      required: false,
      description: '题目解析',
    },
    imageUrl: {
      name: 'imageUrl',
      type: 'url',
      required: false,
      description: '题目图片URL',
    },
  },

  validate: (question: any) => {
    const errors: any[] = [];

    if (!question.content || typeof question.content !== 'string') {
      errors.push({
        field: 'content',
        message: '题目内容不能为空',
        code: 'MISSING_CONTENT',
      });
    }

    if (typeof question.correctAnswer !== 'boolean') {
      errors.push({
        field: 'correctAnswer',
        message: '正确答案必须是布尔值（true 或 false）',
        code: 'INVALID_ANSWER',
      });
    }

    return {
      valid: errors.length === 0,
      errors,
    };
  },

  renderConfig: {
    layout: 'default',
    showFields: ['content', 'imageUrl'],
  },
};
